import { deletePrescription } from "../../api/prescriptionService";

export const useDeletePrescription = (successCallback) => {
    const remove = async (id) => {
        try {
            await deletePrescription(id);
            successCallback();
        } catch (error) {
            console.error("Failed to delete prescription:", error);
            throw error;
        }
    };

    return { remove };
};